export default __webpack_public_path__ + "static/media/schedule-security-exception--red.5270294d.svg";